<script setup lang="ts">
defineProps<{ online: boolean }>();
</script>

<template>
    <span
        class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium"
        :class="online
            ? 'bg-emerald-900/40 text-emerald-300'
            : 'bg-slate-800 text-slate-400'">
        <span class="w-1.5 h-1.5 rounded-full" :class="online ? 'bg-emerald-400' : 'bg-slate-500'"></span>
        {{ online ? 'Online' : 'Offline' }}
    </span>
</template>
